import apiClient from './authService';

const dashboardService = {
  // Get dashboard statistics
  getDashboardStats: async () => {
    const response = await apiClient.get('/dashboard/stats');
    return response.data;
  },

  // Get recent activities
  getRecentActivities: async (limit = 10) => {
    const response = await apiClient.get('/dashboard/activities', {
      params: { limit }
    });
    return response.data;
  },

  // Get admin dashboard statistics
  getAdminDashboardStats: async () => {
    const response = await apiClient.get('/admin/dashboard/stats');
    return response.data;
  }
};

export { dashboardService };

